import {
	CUSTOMER_BEHAVIOR_SWITCHING_BREAKDOWN,
	CUSTOMER_PROFILING_SEGMENTATION_SUMMARY,
} from "constants/paths"

import { ReactComponent as start } from "@livingdesign/pictograms/dist/svg/App_&_Web_Interface/Start.svg"
import { ReactComponent as userHeart } from "assets/icons/user_heart.svg"

export const submodules = [
	{
		featureFlagId: "customerBehaviorCustomerSwitching",
		titleIntlId: "phronesis.customerbehavior.application.switching",
		descriptionIntlId:
			"phronesis.customerbehavior.application.switching.description",
		iconId: start,
		url: CUSTOMER_BEHAVIOR_SWITCHING_BREAKDOWN,
	},
	{
		featureFlagId: "customerBehaviorCustomerProfiling",
		titleIntlId: "phronesis.customerbehavior.application.customerProfiling",
		descriptionIntlId:
			"phronesis.customerbehavior.application.customerProfiling.description",
		iconId: userHeart,
		url: CUSTOMER_PROFILING_SEGMENTATION_SUMMARY,
	},
]
